import { IconWrapper } from '../runtime';
export default IconWrapper('indent-decrease', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.75 2.24951H14.2539M6.75391 7.99951H14.25M1.75 13.7495H14.2539M3.75 5.99976L1.75 7.99951L3.75 9.99976",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});